var render = function render(){var _vm=this,_c=_vm._self._c;return _c('commonSelect',{attrs:{"value":_vm.value,"placeholder":"请选择角色","clearable":_vm.clearable,"idKey":"RoleId","labelKey":"RoleName","get-data-func":_vm.getDataFunc,"disabled":_vm.disabled},on:{"input":v=>_vm.$emit('input',v)}})
}
var staticRenderFns = []

export { render, staticRenderFns }